import React, { ChangeEvent } from "react";
import { Box, TextField, Typography } from "@mui/material";

interface NewCheckInputProps {
  checkKey: string;
  onChangeKey: (event: ChangeEvent<HTMLInputElement>) => void;
  checkValue: string;
  onChangeValue: (event: ChangeEvent<HTMLInputElement>) => void;
}

export function NewCheckInput(props: NewCheckInputProps) {
  return (
    <Box className="horizontal-flex">
      <TextField size="small" fullWidth={true} value={props.checkKey} onChange={props.onChangeKey} />
      <Typography component={"span"}>:</Typography>
      <TextField size="small" fullWidth={true} value={props.checkValue} onChange={props.onChangeValue} />
    </Box>
  );
}
